import { getLastUpdated } from "../api/mockData";

export function Header() {
  return (
    <header className="w-full text-center mb-8 animate-fade-in-up">
      <div className="inline-flex items-center gap-2 mb-4 px-3 py-1.5 rounded-full bg-[var(--color-teal-light)] text-[var(--color-teal-dark)]">
        <span className="inline-block w-2 h-2 rounded-full bg-[var(--color-teal)] animate-[pulse-ring_2s_ease-in-out_infinite]" />
        <span className="text-xs font-medium tracking-wide uppercase" style={{ fontFamily: "var(--font-mono)" }}>
          Live Rates
        </span>
      </div>

      <h1
        className="text-5xl sm:text-6xl font-bold tracking-tight mb-3 text-[var(--color-ink)]"
        style={{ fontFamily: "var(--font-display)", fontWeight: 900 }}
      >
        Currency<br />Dashboard
      </h1>

      <p
        className="text-sm text-[var(--color-ink-light)] tracking-wide"
        style={{ fontFamily: "var(--font-mono)", fontWeight: 300 }}
      >
        Updated {getLastUpdated()}
      </p>
    </header>
  );
}
